export default __webpack_public_path__ + "static/media/20.b9bc3984.png";